import { useRef, useEffect } from 'react';

/**
 * Hooks to verify if the component is mounted and prevent React Warning:
 * "Can only update a mounted or mounting component.
 * This usually means you called setState, replaceState, or forceUpdate on an unmounted component."
 * @returns { React.Ref<boolean> } The reference indicating if the component is mounted or not.
 */
function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}

export default useIsMounted;
